import type { NavSection } from "./types";

export const docsNav: NavSection[] = [
  {
    title: "Getting Started",
    icon: "Rocket",
    basePath: "getting-started",
    items: [
      { title: "Platform Overview", slug: "platform-overview" },
      { title: "Account Setup", slug: "account-setup" },
      { title: "Your First Campaign", slug: "your-first-campaign" },
      { title: "Compliance Setup", slug: "compliance-setup" },
    ],
  },
  {
    title: "Campaigns",
    icon: "Target",
    basePath: "campaigns",
    items: [
      { title: "Creating a Campaign", slug: "creating-a-campaign" },
      { title: "Campaign Channels", slug: "campaign-channels" },
      { title: "Managing Campaigns", slug: "managing-campaigns" },
      { title: "Remarketing", slug: "remarketing" },
      { title: "Campaign Analytics", slug: "campaign-analytics" },
    ],
  },
  {
    title: "AI Voice Agents",
    icon: "Bot",
    basePath: "ai-voice-agents",
    items: [
      { title: "Creating a Voice Agent", slug: "creating-a-voice-agent" },
      { title: "Voice Options", slug: "voice-options" },
      { title: "Agent Playground", slug: "agent-playground" },
      { title: "Call Outcomes", slug: "call-outcomes" },
      { title: "Voicemail Detection", slug: "voicemail-detection" },
      { title: "Call Flow", slug: "call-flow" },
    ],
  },
  {
    title: "SMS Agents",
    icon: "MessageSquareText",
    basePath: "sms-agents",
    items: [
      { title: "Creating an SMS Agent", slug: "creating-an-sms-agent" },
      { title: "SMS Agent Settings", slug: "sms-agent-settings" },
      { title: "AI Auto-Reply", slug: "ai-auto-reply" },
      { title: "SMS Agent Tester", slug: "sms-agent-tester" },
      { title: "SMS Agent Troubleshooting", slug: "sms-agent-troubleshooting" },
    ],
  },
  {
    title: "Multi-Line Dialer",
    icon: "PhoneOutgoing",
    basePath: "multi-line-dialer",
    items: [
      { title: "Running a Session", slug: "running-a-dialer-session" },
      { title: "Hold & Switch", slug: "hold-and-switch" },
      { title: "Dialer Controls", slug: "dialer-controls" },
      { title: "Dialer Reporting", slug: "dialer-reporting" },
    ],
  },
  {
    title: "SMS Broadcasts",
    icon: "Send",
    basePath: "sms-broadcasts",
    items: [
      { title: "Composing a Broadcast", slug: "composing-a-broadcast" },
      { title: "Broadcast Limits", slug: "broadcast-limits" },
      { title: "SMS Templates", slug: "sms-templates" },
    ],
  },
  {
    title: "Voicemail",
    icon: "Voicemail",
    basePath: "voicemail",
    items: [
      { title: "Voicemail Drop", slug: "voicemail-drop" },
      { title: "Ringless Voicemail", slug: "ringless-voicemail" },
      { title: "Voicemail Templates", slug: "voicemail-templates" },
    ],
  },
  {
    title: "Conversations",
    icon: "MessagesSquare",
    basePath: "conversations",
    items: [
      { title: "Inbox Views", slug: "inbox-views" },
      { title: "Replying to Conversations", slug: "replying-to-conversations" },
      { title: "AI Activity Log", slug: "ai-activity-log" },
    ],
  },
  {
    title: "Call Logs",
    icon: "Phone",
    basePath: "call-logs",
    items: [
      { title: "Reviewing Calls", slug: "reviewing-calls" },
      { title: "Call Recordings", slug: "call-recordings" },
    ],
  },
  {
    title: "Contacts",
    icon: "Users",
    basePath: "contacts",
    items: [
      { title: "CSV Upload", slug: "csv-upload" },
      { title: "Managing Contacts", slug: "managing-contacts" },
      { title: "Contact Fields", slug: "contact-fields" },
      { title: "Contracts (E-Signature)", slug: "contracts-e-signature" },
    ],
  },
  {
    title: "Leads",
    icon: "Inbox",
    basePath: "leads",
    items: [
      { title: "Lead Detail Page", slug: "lead-detail" },
      { title: "Lead Sources", slug: "lead-sources" },
      { title: "Buyer Map", slug: "buyer-map" },
      { title: "Lead Finder", slug: "lead-finder" },
    ],
  },
  {
    title: "Opportunities",
    icon: "TrendingUp",
    basePath: "opportunities",
    items: [
      { title: "Managing Opportunities", slug: "managing-opportunities" },
      { title: "Callback Workflow", slug: "callback-workflow" },
      { title: "CRM Essentials", slug: "crm-essentials" },
    ],
  },
  {
    title: "Phone Numbers",
    icon: "Hash",
    basePath: "phone-numbers",
    items: [
      { title: "Purchasing Numbers", slug: "purchasing-numbers" },
      { title: "Included vs Extra", slug: "included-vs-extra" },
    ],
  },
  {
    title: "Reporting",
    icon: "BarChart3",
    basePath: "reporting",
    items: [
      { title: "Campaign Comparison", slug: "campaign-comparison" },
      { title: "Channel Comparison", slug: "channel-comparison" },
      { title: "Trend Charts", slug: "trend-charts" },
    ],
  },
  {
    title: "Automation",
    icon: "Zap",
    basePath: "automation",
    items: [
      { title: "Webhooks", slug: "webhooks" },
      { title: "Triggers", slug: "triggers" },
      { title: "Lead Arrived Trigger", slug: "lead-arrived" },
      { title: "Speed-to-Lead Trigger", slug: "speed-to-lead" },
      { title: "Drip Sequences", slug: "drip-sequences" },
      { title: "Delivery Logs", slug: "delivery-logs" },
    ],
  },
  {
    title: "Settings",
    icon: "Settings",
    basePath: "settings",
    items: [
      { title: "Account Settings", slug: "account-settings" },
      { title: "Notifications", slug: "notifications" },
      { title: "API Keys", slug: "api-keys" },
      { title: "AI Assistant Connection", slug: "ai-assistant-connection" },
      { title: "Caller ID", slug: "caller-id" },
      { title: "Call Outcomes Config", slug: "call-outcomes-config" },
    ],
  },
  {
    title: "Billing",
    icon: "CreditCard",
    basePath: "billing",
    items: [
      { title: "Pricing Plans", slug: "pricing-plans" },
      { title: "Usage Rates", slug: "usage-rates" },
      { title: "Wallet", slug: "wallet" },
      { title: "Auto-Recharge", slug: "auto-recharge" },
      { title: "Usage Dashboard", slug: "usage-dashboard" },
      { title: "Understanding Your Bill", slug: "understanding-your-bill" },
    ],
  },
  {
    title: "Compliance",
    icon: "ShieldCheck",
    basePath: "compliance",
    items: [
      { title: "A2P Registration", slug: "a2p-registration" },
      { title: "TCPA Overview", slug: "tcpa-overview" },
      { title: "Compliance Page Setup", slug: "compliance-page-setup" },
      { title: "Do Not Call", slug: "do-not-call" },
      { title: "AI Disclosure", slug: "ai-disclosure" },
    ],
  },
  {
    title: "Inbound Calls",
    icon: "PhoneIncoming",
    basePath: "inbound-calls",
    items: [
      { title: "Setting Up Inbound", slug: "setting-up-inbound" },
      { title: "Inbound Billing", slug: "inbound-billing" },
    ],
  },
  {
    title: "Best Practices",
    icon: "Lightbulb",
    basePath: "best-practices",
    items: [
      { title: "AI Agent Prompts", slug: "ai-agent-prompts" },
      { title: "Campaign Strategy", slug: "campaign-strategy" },
      { title: "Maximizing Connect Rates", slug: "maximizing-connect-rates" },
      { title: "SMS Engagement", slug: "sms-engagement" },
      { title: "Managing Costs", slug: "managing-costs" },
    ],
  },
  {
    title: "Troubleshooting",
    icon: "LifeBuoy",
    basePath: "troubleshooting",
    items: [
      { title: "Call Issues", slug: "call-issues" },
      { title: "SMS Issues", slug: "sms-issues" },
      { title: "Billing Issues", slug: "billing-issues" },
    ],
  },
  {
    title: "Public API",
    icon: "Code",
    basePath: "public-api",
    items: [
      { title: "Getting Started", slug: "getting-started" },
      { title: "API Reference", slug: "api-reference" },
      { title: "Inbound Leads Webhook", slug: "leads-inbound" },
      { title: "Webhooks", slug: "webhooks" },
      { title: "Structured Extraction", slug: "extraction" },
      { title: "Compliance", slug: "compliance" },
      { title: "FAQ", slug: "faq" },
    ],
  },
  {
    title: "Public API — Integrations",
    icon: "Workflow",
    basePath: "public-api/integrations",
    items: [
      { title: "Go High Level", slug: "go-high-level" },
      { title: "Podio", slug: "podio" },
      { title: "Property Leads", slug: "property-leads" },
      { title: "Inbound Webhook", slug: "inbound-webhook" },
      { title: "Zapier", slug: "zapier" },
      { title: "HubSpot", slug: "hubspot" },
      { title: "HubSpot Free", slug: "hubspot-free" },
      { title: "Raw HTTP", slug: "raw-http" },
    ],
  },
];

/**
 * Resolve the nav section owning a docs slug path, matching the LONGEST
 * `basePath` prefix. Matching only `slug[0]` sends every
 * `public-api/integrations/*` page to the "Public API" section, so the
 * Integrations level never appears in either breadcrumb trail.
 *
 * Returns the section plus the remaining slug ("leaf"), which is what the
 * section's `items` are keyed on.
 */
export function findDocsSection(slugPath: string): {
  section: NavSection | undefined;
  leaf: string;
} {
  const section = docsNav
    .filter(
      (s) => slugPath === s.basePath || slugPath.startsWith(`${s.basePath}/`),
    )
    .sort((a, b) => b.basePath.length - a.basePath.length)[0];

  if (!section) return { section: undefined, leaf: slugPath };
  return { section, leaf: slugPath.slice(section.basePath.length + 1) };
}
